"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../config/constants");
class LitPrivacyConstants {
}
LitPrivacyConstants.LIT_ACTIONS_CID = {
    PROOF_OF_IDENTITY: constants_1.PROOF_OF_IDENTITY_ACTION_CID,
    PROOF_OF_MEMBERSHIP: constants_1.PROOF_OF_MEMBERSHIP_ACTION_CID,
};
LitPrivacyConstants.IDENTITY_PROOF_SIGNER_PKP = {
    PUBLIC_KEY: constants_1.IDENTITY_PROOF_SIGNER_PKP_PUBLIC_KEY,
    ADDRESS: constants_1.IDENTITY_PROOF_SIGNER_PKP_ADDRESS,
};
LitPrivacyConstants.MEMBERSHIP_PROOF_SIGNER_PKP = {
    PUBLIC_KEY: constants_1.MEMBERSHIP_PROOF_SIGNER_PKP_PUBLIC_KEY,
    ADDRESS: constants_1.MEMBERSHIP_PROOF_SIGNER_PKP_ADDRESS,
};
exports.default = LitPrivacyConstants;
